//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

	props: {
		basketUrl: String
	},

	computed: {

		selectedBasket()
		{
			return this.$store.getters.selectedBasket;
		},

		baskets()
		{
			return this.$store.getters.notSelectedBaskets;
		},

		selectedColorClass()
		{
			return this.getColorClass(this.selectedBasket);
		},

	},

	methods: {

		getColorClass(basket)
		{
			return basket.COLOR ? 'btn-colored--' + basket.COLOR.toLowerCase().replace('#', '') : '';
		},

		onClick(code)
		{
			KTApp.blockPage();
			this.$store.dispatch('selectBasket', code);
		},

	}

}
